// extracted by mini-css-extract-plugin
export var acitonButtons = "_hi-0";
export var additionalIcon = "_hi-f";
export var block = "_hi-1";
export var blockContent = "_hi-7";
export var blockDescription = "_hi-8";
export var blockIcon = "_hi-9";
export var blockTitle = "_hi-6";
export var border = "_hi-a";
export var center = "_hi-l";
export var edge = "_hi-b";
export var edgeLabel = "_hi-c";
export var edgePath = "_hi-d";
export var error = "_hi-e";
export var flowchart = "_hi-g";
export var flowchartContent = "_hi-h";
export var highlighted = "_hi-3";
export var hover = "_hi-4";
export var icon = "_hi-i";
export var left = "_hi-m";
export var navButton = "_hi-j";
export var navButtons = "_hi-k";
export var right = "_hi-n";
export var selected = "_hi-2";
export var small = "_hi-5";